export enum Stage {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export type StageType = keyof typeof Stage;

export const StageLabels: Record<Stage, string> = {
  [Stage.IN_PROGRESS]: 'Em Andamento',
  [Stage.COMPLETED]: 'Concluído',
};

export const StageColors: Record<Stage, string> = {
  [Stage.IN_PROGRESS]: 'text-orange-600',
  [Stage.COMPLETED]: 'text-green-600',
};

const DEFAULT_BASE_CLASSES = 'px-3 py-1 rounded-full text-xs/3.5 font-medium inline-block w-full';

export function getStageClasses(stage: Stage, baseClasses: string = DEFAULT_BASE_CLASSES): string {
  if (stage === Stage.IN_PROGRESS) {
    return `${baseClasses} bg-green-19 text-white dark:bg-green-20 dark:text-gray-07`;
  }
  return `${baseClasses} bg-gray-02 text-gray-07`;
}
